// V5.68 : Onglet "Mes Missions" — Veille juridique supprimée
import { motion } from 'framer-motion';
import { Briefcase } from 'lucide-react';
import { MesMissionsEnCours } from '../MesMissionsEnCours';

export const MissionsTab = ({ setActiveTab }) => {
  return (
    <div className="space-y-6" data-testid="missions-tab">
      <div>
        <h2 className="font-orbitron text-2xl md:text-3xl font-bold text-white mb-2 flex items-center gap-3">
          <Briefcase className="w-8 h-8 text-success" />
          Mes Missions
        </h2>
        <p className="text-gray-400 font-mono text-sm">// GESTION_MISSIONS_ACTIVES</p>
      </div>
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <MesMissionsEnCours />
      </motion.div>
    </div>
  );
};

export default MissionsTab;
